import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ReminderRequestDto } from '../../dto/reminder-request-dto';
import { ReminderTopic } from '../../dto/ReminderTopic';
import { ModalButtons, SpinnerProps } from '../../../shared/component/modal-container/modal-container.component';
import { OrganizationWithAccesses } from 'src/app/core/component/hornavbar/dto/InitDataDTO';
import { Fund } from 'src/app/domain/fund-performance/dto/Fund';
import { NOTIFICATIONS, NotificationsService } from 'src/app/core/service/notifications.service';

@Component({
  selector: 'app-notifications-modal-form',
  templateUrl: './reminder-form.component.html',
  styleUrls: ['./reminder-form.component.scss'],
})
export class ReminderFormComponent implements OnInit, OnChanges {
  @Output() formEmitter = new EventEmitter<ReminderRequestDto>();
  @Output() closeModal = new EventEmitter<void>();
  @Input() organizationsWithRole: OrganizationWithAccesses[];
  @Input() selectedFund: Fund;
  @Input() reminderFundName: string;
  @Input() body: ReminderRequestDto = new ReminderRequestDto(
    undefined, false, undefined, undefined,
    undefined, undefined, undefined, undefined);

  @Input() isAdminInsideOrg: boolean;
  @Input() title = 'Create notification';

  notificationForm = new FormGroup({
    isPersonal: new FormControl<boolean>(null),
    deadline: new FormControl<Date>(null),
    reminderDate: new FormControl<Date>(null),
    topic: new FormControl<ReminderTopic | string>(null),
    description: new FormControl<string>(null),
    fundUUID: new FormControl<string>(null),
    isCompleted: new FormControl<boolean>(null),
    id: new FormControl<number>(null),
    fundSearch: new FormControl(),
  });

  modalButtons: ModalButtons = {
    close: true,
    apply: 'Apply',
    dismiss: 'Cancel',
  };

  spinnerProps: SpinnerProps = {
    isSpinnerActive: false,
    notActiveOnApply: true,
  };

  topics: (string | ReminderTopic)[] = [];
  showFundSelector = false;
  filteredOrgsWithRole: OrganizationWithAccesses[];
  fundFromReminder: Fund;

  constructor(
    private formBuilder: FormBuilder,
    private notificationService: NotificationsService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.initData();
    // Parse topics to have only values. Otherwise because of the <any> in enum, it contains keys as well.
    this.topics = Object.values(ReminderTopic);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // in case the input value is provided
    if (changes.organizationsWithRole) {
      this.getAvailableOrgs();
    }
  }

  initData(): void {
    this.notificationForm = this.formBuilder.group({
      isPersonal: new FormControl(this.body.isPersonal, { updateOn: 'change' }),
      deadline: new FormControl(this.body.deadline, { updateOn: 'change' }),
      reminderDate: new FormControl(this.body.reminderDate, { validators: [Validators.required], updateOn: 'change' }),
      topic: new FormControl(this.body.topic, { validators: [Validators.required], updateOn: 'change' }),
      description: new FormControl(this.body.description, { updateOn: 'change' }),
      fundUUID: new FormControl(this.body.fundUUID, { validators: [Validators.required], updateOn: 'change' }),
      isCompleted: new FormControl(this.body.isCompleted),
      id: new FormControl(this.body.id),
      fundSearch: new FormControl(),
    });
    const org = this.organizationsWithRole.find((el) => el.organization.funds.find((fund) => fund.name === this.reminderFundName));
    const f = org?.organization.funds.filter((fund) => fund.name === this.reminderFundName);
    this.notificationForm.patchValue({ fundUUID: this.reminderFundName ? f[0]?.uuid : this.selectedFund.uuid });
    if (f) {
      this.fundFromReminder = f[0];
    }
  }

  getAvailableOrgs(): void {
    this.filteredOrgsWithRole = this.organizationsWithRole =
      this.organizationsWithRole.filter((orgWithRole) => orgWithRole.userAccesses.isFmsAdmin());
  }

  filterOrgs(fundName: string): void {
    this.filteredOrgsWithRole =
      this.organizationsWithRole.filter((orgWithRole) => this.fundInsideOrg(orgWithRole.organization.funds, fundName));
  }

  emitSelectedFund(fund: Fund): void {
    this.selectedFund = fund;
    this.notificationForm.patchValue({ fundUUID: fund.uuid });
    this.showFundSelector = false;
    this.fundFromReminder = fund;
  }

  resetFundSearch(): void {
    this.notificationForm.patchValue({ fundSearch: '' });
    this.filteredOrgsWithRole = this.organizationsWithRole;
  }

  confirm(): void {
    if (this.deadLineIsNotValid()) {
      return;
    }
    this.formEmitter.emit(this.notificationForm.value as ReminderRequestDto);
  }

  deadLineIsNotValid(): boolean {
    const reminderDate = new Date(this.notificationForm.value.reminderDate);
    const deadlineDate = new Date(this.notificationForm.value.deadline);
    if (reminderDate > deadlineDate) {
      this.notificationService.error(NOTIFICATIONS.DEADLINE_NOTIFICATION_ERROR);
      return true;
    }
    return false;
  }

  private fundInsideOrg(funds: Fund[], fundName: string): boolean {
    for (const fund of funds) {
      if (fund.name.toLowerCase().includes(fundName.toLowerCase())) {
        return true;
      }
    }
    return false;
  }
}
